import { trackEventWithObject } from '@/utils/gaDataPush';
import useStore from '@/store/useStore';

export default function Stores() {
  const { store } = useStore(state => state.showroom);

  return (
    <a
      href={store?.store_url || '/stores/'}
      onClick={() => {
        trackEventWithObject({
          event: 'header',
          general_event_category: 'Stores',
          general_event_section: 'Main Icon',
          general_event_details: 'Undefined',
        });
      }}
      className="tw-font-nav-link"
    >
      Stores
    </a>
  );
}
